import $ from 'jquery';

export default {
  name: 'menu-items',
  components: {},
  props: {
    menu: Array,
    clicked: Number
  },
  data() {
    return {
      show: false,
      shown: -1,
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    letsShow(key) {
      if (this.clicked == 0) {
        this.shown = key;
      }
      $(".myIcon").animate(
        {
          "margin-block-end": "0px",
          "padding-inline-start": "10px",
          "margin-block-start": "0px",
          "padding-top": "12px"
        },
        1
      );
    },
    letsLeave() {
      if (this.clicked == 0) {
        this.shown = -1;
        $(".myIcon").animate(
          {
            "padding-block-end": "10px",
            "padding-inline-start": "10px",
            "padding-block-start": "10px",
            "padding-top": "12px"
          },
          1
        );
      }
    },
    redirect(name) {
      this.$router.push({ name: name }).catch(() => { });
    },
  }
}


